const $qs = (css, parent = document) => parent.querySelector(css);
const $qsa = (css, parent = document) => parent.querySelectorAll(css);

export { $qs, $qsa };